export const localDev = false

export const filterPath = ['/visitor', '/app/personInfo']



// WEBPACK FOOTER //
// ./src/utils/constant.js